import React from "react";
import { Outlet, Navigate } from 'react-router-dom'

const PrivateRoutes = (auth) => {
    return (
        auth.auth ? <Outlet /> : <Navigate to="/supervisorlogin" />
    )
}

export default PrivateRoutes